"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GestureTwoFingers = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_GestureTwoFingers_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 13,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.563 2.909c.025-.11.038-.223.038-.34C6.6 1.703 5.89 1 5.014 1c-.588 0-1.1.316-1.375.786l-.052-.001C2.71 1.785 2 2.487 2 3.355c0 .774.568 1.418 1.315 1.546.038.117.083.232.135.344l1.37 2.958-.263.344c-.592.779-1 1.678-1.194 2.632-.16.786.252 1.576.99 1.906L8.38 14.89c.043.02.082.046.115.078L9.543 16 15 13.85l-.51-1.008a8.448 8.448 0 0 1-.829-2.61l-.15-1.04a2.327 2.327 0 0 0-.804-1.444l-2.361-1.994a1.462 1.462 0 0 0-1.201-.32l-.464.083-2.118-2.608Zm1.873 4.955L5.387 3.358a.274.274 0 0 1 .27.105l3.73 4.594a.533.533 0 0 0 .743.08.52.52 0 0 0 .081-.736l-.765-.942c.078.009.153.04.213.091l2.36 1.994c.242.204.4.487.445.796l.15 1.04a9.487 9.487 0 0 0 .923 2.92l-3.74 1.474-.555-.548a1.448 1.448 0 0 0-.425-.29l-4.028-1.804a.672.672 0 0 1-.39-.747 5.425 5.425 0 0 1 .85-1.998l.534 1.59a.53.53 0 0 0 .668.332.522.522 0 0 0 .335-.662l-.862-2.57-1.513-3.268a2.056 2.056 0 0 1-.19-.864c0-.035.008-.056.016-.068a.12.12 0 0 1 .045-.04.147.147 0 0 1 .133-.01c.012.007.03.02.049.048l3.093 4.571c.162.24.49.305.734.144a.52.52 0 0 0 .145-.726Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_GestureTwoFingers_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = GestureTwoFingers;
exports["default"] = _default;